export const UPDATE_CARE_PROVIDER_FAILURE = 'UPDATE_CARE_PROVIDER_FAILURE';

export const updateCareProviderFailure = error => ({
    type: UPDATE_CARE_PROVIDER_FAILURE,
    payload: error,
    error: true,
});
